import React from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Button from '../Button';
import InputField from '../InputField';
import FormErrorMessage from '../FormErrorMessage';

const SessionChatInvitationForm = ({ onSubmit, isLoading, children }) => {
  const { t } = useTranslation('components');
  const { register, handleSubmit: wrapSubmit, errors, formState } = useForm({ mode: 'onChange' });

  const isSubmitDisabled = !formState.isValid || isLoading;

  const handleSubmit = data => {
    onSubmit({
      ...data,
    });
  };

  return (
    <form onSubmit={wrapSubmit(handleSubmit)} data-component="SessionChatInvitationForm">
      <h3 className="font-semibold mt-4">{t('SessionChatInvitationForm.groupName')}</h3>
      <div className="mt-1">
        <InputField name="title" ref={ref => register(ref, { required: true })} defaultValue="" />
      </div>
      {errors.title && <FormErrorMessage message={errors.title.message} />}

      {children}

      <div className="flex justify-end mt-8">
        <Button type="submit" isDisabled={isSubmitDisabled} isLoading={isLoading}>
          {t('SessionChatInvitationForm.submit')}
        </Button>
      </div>
    </form>
  );
};

SessionChatInvitationForm.propTypes = {
  onSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
  children: PropTypes.node,
};

SessionChatInvitationForm.defaultProps = {
  onSubmit: () => {},
};

export default SessionChatInvitationForm;
